import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

export interface DashboardSubject {
  i18nKey?: string;
  name?: string;
  /**
   * Classe FontAwesome facultative. Les matières n'en portent pas : la colonne
   * `icon_url` de la base contient des noms Material Symbols, qu'aucune police
   * chargée par l'application ne sait rendre — un `<i>` vide en résultait.
   */
  icon?: string;

  /**
   * Matière épinglée par l'élève.
   *
   * <p>Le serveur les rend déjà en tête, mais rien ne le disait à l'écran :
   * l'ordre seul ne se remarque pas. L'étoile rend visible un choix que l'élève
   * a fait ailleurs — sans quoi le module de favoris n'existe que dans la liste
   * où on le règle.</p>
   */
  isFavorite?: boolean;
  color: string;
  progress: number;
}

@Component({
  selector: 'app-subjects-card',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule],
  templateUrl: './subjects-card.component.html',
  styleUrl: './subjects-card.component.css',
})
export class SubjectsCardComponent {
  @Input() subjects: DashboardSubject[] = [];
  @Input() titleKey: string = 'DASHBOARD.PRIMARY.SUBJECTS_TITLE';
  @Input() iconClass: string = 'fa-solid fa-book';
  @Input() iconBg: string = 'var(--cgreen5)';
  @Input() iconColor: string = '#fff';
  @Input() columns: number = 3;
  /** When set, renders a "View all" link in the header that routes to this URL. */
  @Input() viewAllLink?: string;
  @Input() viewAllLabelKey: string = 'DASHBOARD.VIEW_ALL';
}
